import React from 'react';

/**
 * Visas när något i kontrollen inte var i ordning. Den som fyller i väljer
 * "åtgärdat direkt" (beskriv vad som gjordes) eller "åtgärd behövs" (vad + senast när).
 */

export interface DeviationState {
    mode: 'fixed' | 'action';
    deviationNote: string;
    actionNote: string;
    actionDue: string;
}

export const emptyDeviation = (): DeviationState => ({ mode: 'fixed', deviationNote: '', actionNote: '', actionDue: '' });

interface Props {
    value: DeviationState;
    onChange: (v: DeviationState) => void;
}

const input: React.CSSProperties = {
    width: '100%', boxSizing: 'border-box', border: '1px solid #ccc', borderRadius: 6, padding: 9, fontSize: 15, fontFamily: 'inherit',
};
const choice = (on: boolean): React.CSSProperties => ({
    flex: 1, minWidth: 160, padding: '10px 12px', borderRadius: 8, cursor: 'pointer', textAlign: 'left', fontFamily: 'inherit', fontSize: 14,
    border: `2px solid ${on ? '#0f3460' : '#ccc'}`, background: on ? '#e8f0fe' : 'white', color: '#222',
});

const DeviationChoice: React.FC<Props> = ({ value, onChange }) => {
    const set = (patch: Partial<DeviationState>) => onChange({ ...value, ...patch });
    return (
        <div style={{ marginTop: 12, padding: 14, borderRadius: 8, border: '1px solid #f1b0b7', background: '#fff5f5' }}>
            <div style={{ fontWeight: 600, fontSize: 14, color: '#b02a37', marginBottom: 8 }}>Något var inte i ordning. Vad händer nu?</div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 10 }}>
                <button type="button" onClick={() => set({ mode: 'fixed' })} style={choice(value.mode === 'fixed')}>
                    <b>Åtgärdat direkt</b><div style={{ fontSize: 12, color: '#555' }}>Felet är redan fixat</div>
                </button>
                <button type="button" onClick={() => set({ mode: 'action' })} style={choice(value.mode === 'action')}>
                    <b>Åtgärd behövs</b><div style={{ fontSize: 12, color: '#555' }}>Någon måste göra något senare</div>
                </button>
            </div>
            {value.mode === 'fixed' ? (
                <div>
                    <label style={{ display: 'block', fontWeight: 600, fontSize: 14, marginBottom: 4 }}>Vad var fel och vad gjordes åt det? *</label>
                    <textarea value={value.deviationNote} onChange={e => set({ deviationNote: e.target.value })} rows={3} style={input} />
                </div>
            ) : (
                <div>
                    <label style={{ display: 'block', fontWeight: 600, fontSize: 14, marginBottom: 4 }}>Vad behöver göras? *</label>
                    <textarea value={value.actionNote} onChange={e => set({ actionNote: e.target.value })} rows={3} style={input} />
                    <label style={{ display: 'block', fontWeight: 600, fontSize: 14, margin: '10px 0 4px' }}>Ska vara klart senast *</label>
                    <input type="date" value={value.actionDue} onChange={e => set({ actionDue: e.target.value })} style={{ ...input, maxWidth: 220 }} />
                    <div style={{ fontSize: 12, color: '#777', marginTop: 6 }}>Kontrollen sparas som gjord, men åtgärden ligger kvar under Att göra tills den klarmarkeras.</div>
                </div>
            )}
        </div>
    );
};

export default DeviationChoice;
